import { useMemo } from "react"
import Tabs from "@/v2-backoffice-client/components/tabs"
import { useLicenseCoverageQuery } from "@/v2-backoffice-client/license/coverage/license.coverage.query"
import { summarizeCoverage } from "@/v2-backoffice-client/license/coverage/license.coverage.utils"
import { LICENSING_VIEW_COVERAGE } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Coverage tab trigger: how many licenses have an
// issue where billing, invoicing and access disagree. Owns its own read of
// the query — Apollo dedupes it against the board's — so the count stays
// live no matter which tab is open.
function LicenseCoverageTabTrigger() {
  const { data, previousData, loading } = useLicenseCoverageQuery()
  const rows = (data ?? previousData)?.getLicenseCoverage

  const issueCount = useMemo(() => {
    if (!rows) return 0
    const summary = summarizeCoverage(rows)
    return summary.critical + summary.warning
  }, [rows])

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_COVERAGE}
      iconSrc="chart-gantt"
      isLoading={loading && !data && !previousData}
      count={issueCount}
    >
      Coverage
    </Tabs.Trigger>
  )
}

export default LicenseCoverageTabTrigger
